


// // import React, { useState, useEffect } from "react";
// // import { useParams, useNavigate, Link } from "react-router-dom";
// // import { useSelector } from "react-redux";
// // import { Spin, message, Modal } from "antd";
// // import {
// //     VideoCameraOutlined,
// //     CalendarOutlined,
// //     ClockCircleOutlined,
// //     DollarOutlined,
// //     ArrowLeftOutlined,
// //     CheckCircleOutlined,
// //     UserOutlined,
// //     TagsOutlined,
// //     PlayCircleOutlined,
// //     LoginOutlined,
// //     SafetyCertificateOutlined,
// //     TeamOutlined,
// //     FireOutlined,
// //     BulbOutlined,
// //     LoadingOutlined,
// // } from "@ant-design/icons";
// // import dayjs from "dayjs";
// // import liveTrainingService from "../../../services/liveTraining.service";

// // const LiveTrainingDetails = () => {
// //     const { id } = useParams();
// //     const navigate = useNavigate();
// //     const { user: currentUser } = useSelector((state) => state.auth);

// //     const [training, setTraining] = useState(null);
// //     const [loading, setLoading] = useState(true);
// //     const [showLoginModal, setShowLoginModal] = useState(false);
// //     const [hasPurchased, setHasPurchased] = useState(false);
// //     const [isProcessingPayment, setIsProcessingPayment] = useState(false);

// //     useEffect(() => {
// //         const fetchTraining = async () => {
// //             try {
// //                 setLoading(true);
// //                 const data = await liveTrainingService.getById(id);
// //                 setTraining(data);

// //                 if (currentUser?.id) {
// //                     const checkResult = await liveTrainingService.checkPurchase(currentUser.id, id);
// //                     setHasPurchased(checkResult.hasPurchased);
// //                 }
// //             } catch (error) {
// //                 console.error("Erreur:", error);
// //                 message.error("Formation introuvable");
// //                 navigate("/live-trainings");
// //             } finally {
// //                 setLoading(false);
// //             }
// //         };
// //         if (id) fetchTraining();
// //     }, [id, navigate, currentUser?.id]);

// //     const handleSubscribe = () => {
// //         if (!currentUser) {
// //             setShowLoginModal(true);
// //             return;
// //         }

// //         if (hasPurchased) {
// //             message.info("Vous êtes déjà inscrit à cette formation !");
// //             return;
// //         }

// //         // Rediriger vers la page de paiement dédiée
// //         navigate(`/pay/live-training/${training.id}`);
// //     };




// //     const formatLiveDate = (date) => {
// //         if (!date) return "Date à venir";
// //         return dayjs(date).format("dddd DD MMMM YYYY • HH:mm");
// //     };

// //     const getTimeUntil = (date) => {
// //         if (!date) return null;
// //         const target = dayjs(date);
// //         const now = dayjs();
// //         if (target.isBefore(now)) return { passed: true };

// //         const days = target.diff(now, "day");
// //         const hours = target.diff(now, "hour") % 24;
// //         const minutes = target.diff(now, "minute") % 60;

// //         return { passed: false, days, hours, minutes };
// //     };

// //     const timeUntil = training ? getTimeUntil(training.liveDate) : null;
// //     const isPast = timeUntil?.passed;

// //     if (loading) {
// //         return (
// //             <div style={{
// //                 minHeight: '100vh',
// //                 display: 'flex',
// //                 alignItems: 'center',
// //                 justifyContent: 'center',
// //                 background: '#f8f9fa'
// //             }}>
// //                 <Spin size="large" tip="Chargement..." />
// //             </div>
// //         );
// //     }

// //     if (!training) return null;

// //     return (
// //         <div className="details-container">
// //             <style>{`
// //                 .details-container { min-height: 100vh; background: #f8f9fa; }
// //                 .hero {
// //                     background: linear-gradient(135deg, #ee5a6f 0%, #ff6b6b 50%, #ffa07a 100%);
// //                     padding: 32px 0 60px;
// //                     color: white;
// //                     position: relative;
// //                     overflow: hidden;
// //                 }
// //                 .hero::before {
// //                     content: '';
// //                     position: absolute;
// //                     top: 0; left: 0;
// //                     width: 100%; height: 100%;
// //                     background-image:
// //                         radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%),
// //                         radial-gradient(circle at 80% 80%, rgba(255,255,255,0.1) 0%, transparent 50%);
// //                 }
// //                 .hero-content {
// //                     max-width: 1200px;
// //                     margin: 0 auto;
// //                     padding: 0 32px;
// //                     position: relative;
// //                     z-index: 1;
// //                 }
// //                 .back-button {
// //                     display: inline-flex;
// //                     align-items: center;
// //                     gap: 8px;
// //                     color: rgba(255,255,255,0.9);
// //                     background: rgba(255,255,255,0.15);
// //                     backdrop-filter: blur(10px);
// //                     padding: 8px 18px;
// //                     border-radius: 30px;
// //                     text-decoration: none;
// //                     font-size: 14px;
// //                     font-weight: 500;
// //                     transition: all 0.2s;
// //                     margin-bottom: 24px;
// //                     border: 1px solid rgba(255,255,255,0.2);
// //                 }
// //                 .back-button:hover {
// //                     background: rgba(255,255,255,0.25);
// //                     color: white;
// //                     transform: translateX(-4px);
// //                 }
// //                 .hero-grid {
// //                     display: grid;
// //                     grid-template-columns: 1.5fr 1fr;
// //                     gap: 40px;
// //                     align-items: start;
// //                 }
// //                 @media (max-width: 1024px) { .hero-grid { grid-template-columns: 1fr; } }
// //                 .hero-info .badges {
// //                     display: flex;
// //                     gap: 8px;
// //                     margin-bottom: 16px;
// //                     flex-wrap: wrap;
// //                 }
// //                 .live-tag {
// //                     background: rgba(255,0,0,0.95);
// //                     color: white;
// //                     padding: 6px 14px;
// //                     border-radius: 20px;
// //                     font-size: 11px;
// //                     font-weight: 700;
// //                     letter-spacing: 1.5px;
// //                     display: inline-flex;
// //                     align-items: center;
// //                     gap: 6px;
// //                     box-shadow: 0 4px 12px rgba(0,0,0,0.2);
// //                 }
// //                 .live-tag::before {
// //                     content: '';
// //                     width: 8px; height: 8px;
// //                     background: white;
// //                     border-radius: 50%;
// //                     animation: pulse 1.5s infinite;
// //                 }
// //                 @keyframes pulse {
// //                     0%, 100% { opacity: 1; }
// //                     50% { opacity: 0.4; }
// //                 }
// //                 .category-tag {
// //                     background: rgba(255,255,255,0.25);
// //                     backdrop-filter: blur(10px);
// //                     color: white;
// //                     padding: 6px 14px;
// //                     border-radius: 20px;
// //                     font-size: 12px;
// //                     font-weight: 600;
// //                     text-transform: uppercase;
// //                     letter-spacing: 1px;
// //                     border: 1px solid rgba(255,255,255,0.3);
// //                 }
// //                 .purchased-tag {
// //                     background: rgba(82,196,26,0.95);
// //                     color: white;
// //                     padding: 6px 14px;
// //                     border-radius: 20px;
// //                     font-size: 12px;
// //                     font-weight: 700;
// //                     display: inline-flex;
// //                     align-items: center;
// //                     gap: 6px;
// //                     box-shadow: 0 4px 12px rgba(0,0,0,0.2);
// //                 }
// //                 .hero-title {
// //                     font-size: 42px;
// //                     font-weight: 800;
// //                     line-height: 1.15;
// //                     margin: 0 0 16px;
// //                     text-shadow: 0 2px 10px rgba(0,0,0,0.1);
// //                 }
// //                 .hero-desc {
// //                     font-size: 17px;
// //                     line-height: 1.6;
// //                     opacity: 0.95;
// //                     margin-bottom: 24px;
// //                 }
// //                 .hero-meta {
// //                     display: flex;
// //                     gap: 24px;
// //                     flex-wrap: wrap;
// //                     font-size: 14px;
// //                 }
// //                 .hero-meta-item {
// //                     display: flex;
// //                     align-items: center;
// //                     gap: 8px;
// //                     color: rgba(255,255,255,0.95);
// //                 }
// //                 .countdown-card {
// //                     background: white;
// //                     border-radius: 20px;
// //                     padding: 24px;
// //                     box-shadow: 0 10px 40px rgba(0,0,0,0.15);
// //                     color: #1a1a1a;
// //                 }
// //                 .countdown-card.purchased { border: 3px solid #52c41a; }
// //                 .countdown-image {
// //                     width: 100%;
// //                     height: 220px;
// //                     border-radius: 12px;
// //                     object-fit: cover;
// //                     margin-bottom: 20px;
// //                 }
// //                 .countdown-image-placeholder {
// //                     width: 100%;
// //                     height: 220px;
// //                     border-radius: 12px;
// //                     background: linear-gradient(135deg, #ee5a6f 0%, #ff6b6b 100%);
// //                     display: flex;
// //                     align-items: center;
// //                     justify-content: center;
// //                     color: white;
// //                     font-size: 80px;
// //                     margin-bottom: 20px;
// //                 }
// //                 .countdown-title {
// //                     font-size: 13px;
// //                     text-transform: uppercase;
// //                     letter-spacing: 1px;
// //                     color: #6b7280;
// //                     margin-bottom: 12px;
// //                     text-align: center;
// //                     font-weight: 600;
// //                 }
// //                 .countdown-grid {
// //                     display: grid;
// //                     grid-template-columns: repeat(3, 1fr);
// //                     gap: 8px;
// //                     margin-bottom: 20px;
// //                 }
// //                 .countdown-cell {
// //                     background: linear-gradient(135deg, #fff5f5 0%, #ffe5e8 100%);
// //                     border-radius: 12px;
// //                     padding: 16px 8px;
// //                     text-align: center;
// //                     border: 1px solid #ffd1d6;
// //                 }
// //                 .countdown-value {
// //                     font-size: 32px;
// //                     font-weight: 800;
// //                     color: #ee5a6f;
// //                     line-height: 1;
// //                 }
// //                 .countdown-label {
// //                     font-size: 11px;
// //                     text-transform: uppercase;
// //                     color: #6b7280;
// //                     margin-top: 4px;
// //                     font-weight: 600;
// //                     letter-spacing: 0.5px;
// //                 }
// //                 .price-section {
// //                     background: linear-gradient(135deg, #fff5f5 0%, #ffe5e8 100%);
// //                     padding: 16px;
// //                     border-radius: 12px;
// //                     text-align: center;
// //                     margin-bottom: 16px;
// //                 }
// //                 .price-label {
// //                     font-size: 12px;
// //                     color: #6b7280;
// //                     text-transform: uppercase;
// //                     letter-spacing: 1px;
// //                     font-weight: 600;
// //                 }
// //                 .price-value {
// //                     font-size: 36px;
// //                     font-weight: 800;
// //                     color: #ee5a6f;
// //                     line-height: 1;
// //                     margin-top: 4px;
// //                 }
// //                 .btn-subscribe {
// //                     width: 100%;
// //                     padding: 16px;
// //                     background: linear-gradient(135deg, #ee5a6f 0%, #ff6b6b 100%);
// //                     color: white;
// //                     border: none;
// //                     border-radius: 12px;
// //                     font-size: 16px;
// //                     font-weight: 700;
// //                     cursor: pointer;
// //                     display: flex;
// //                     align-items: center;
// //                     justify-content: center;
// //                     gap: 10px;
// //                     box-shadow: 0 8px 24px rgba(238,90,111,0.4);
// //                     transition: all 0.3s;
// //                     text-transform: uppercase;
// //                     letter-spacing: 1px;
// //                 }
// //                 .btn-subscribe:hover:not(:disabled) {
// //                     transform: translateY(-2px);
// //                     box-shadow: 0 12px 32px rgba(238,90,111,0.5);
// //                 }
// //                 .btn-subscribe:disabled { opacity: 0.6; cursor: not-allowed; }
// //                 .btn-purchased {
// //                     width: 100%;
// //                     padding: 16px;
// //                     background: linear-gradient(135deg, #52c41a 0%, #389e0d 100%);
// //                     color: white;
// //                     border: none;
// //                     border-radius: 12px;
// //                     font-size: 16px;
// //                     font-weight: 700;
// //                     cursor: default;
// //                     display: flex;
// //                     align-items: center;
// //                     justify-content: center;
// //                     gap: 10px;
// //                     box-shadow: 0 8px 24px rgba(82,196,26,0.4);
// //                     text-transform: uppercase;
// //                     letter-spacing: 1px;
// //                 }
// //                 .past-badge {
// //                     background: #f3f4f6;
// //                     color: #6b7280;
// //                     padding: 14px;
// //                     border-radius: 12px;
// //                     text-align: center;
// //                     font-weight: 600;
// //                     border: 2px dashed #d1d5db;
// //                 }
// //                 .meeting-link-box {
// //                     background: #f6ffed;
// //                     border: 1px solid #b7eb8f;
// //                     padding: 12px;
// //                     border-radius: 8px;
// //                     margin-top: 12px;
// //                     text-align: center;
// //                 }
// //                 .meeting-link-box a {
// //                     color: #389e0d;
// //                     font-weight: 600;
// //                     text-decoration: none;
// //                 }
// //                 .content-section {
// //                     max-width: 1200px;
// //                     margin: -40px auto 0;
// //                     padding: 0 32px 60px;
// //                     position: relative;
// //                     z-index: 2;
// //                 }
// //                 .content-grid {
// //                     display: grid;
// //                     grid-template-columns: 1fr 320px;
// //                     gap: 32px;
// //                 }
// //                 @media (max-width: 1024px) { .content-grid { grid-template-columns: 1fr; } }
// //                 .main-content { display: flex; flex-direction: column; gap: 24px; }
// //                 .section-card {
// //                     background: white;
// //                     border-radius: 20px;
// //                     padding: 28px;
// //                     box-shadow: 0 4px 16px rgba(0,0,0,0.05);
// //                     border: 1px solid #f0f0f0;
// //                 }
// //                 .section-header {
// //                     display: flex;
// //                     align-items: center;
// //                     gap: 12px;
// //                     margin-bottom: 16px;
// //                     padding-bottom: 16px;
// //                     border-bottom: 2px solid #f5f7fa;
// //                 }
// //                 .section-icon {
// //                     width: 40px;
// //                     height: 40px;
// //                     border-radius: 12px;
// //                     display: flex;
// //                     align-items: center;
// //                     justify-content: center;
// //                     color: white;
// //                     font-size: 18px;
// //                     background: linear-gradient(135deg, #ee5a6f 0%, #ff6b6b 100%);
// //                 }
// //                 .section-title {
// //                     margin: 0;
// //                     font-size: 20px;
// //                     font-weight: 700;
// //                     color: #1a1a1a;
// //                 }
// //                 .section-content {
// //                     color: #4b5563;
// //                     line-height: 1.8;
// //                     font-size: 15px;
// //                 }
// //                 .sidebar {
// //                     display: flex;
// //                     flex-direction: column;
// //                     gap: 16px;
// //                     position: sticky;
// //                     top: 80px;
// //                     height: fit-content;
// //                 }
// //                 @media (max-width: 1024px) { .sidebar { position: static; } }
// //                 .info-card {
// //                     background: white;
// //                     border-radius: 16px;
// //                     padding: 20px;
// //                     box-shadow: 0 4px 16px rgba(0,0,0,0.05);
// //                     border: 1px solid #f0f0f0;
// //                 }
// //                 .info-card-title {
// //                     font-size: 12px;
// //                     color: #6b7280;
// //                     text-transform: uppercase;
// //                     letter-spacing: 1px;
// //                     font-weight: 600;
// //                     margin: 0 0 12px;
// //                 }
// //                 .info-list { display: flex; flex-direction: column; gap: 12px; }
// //                 .info-item { display: flex; align-items: flex-start; gap: 10px; padding: 8px 0; }
// //                 .info-item .anticon {
// //                     color: #ee5a6f;
// //                     font-size: 18px;
// //                     margin-top: 2px;
// //                     flex-shrink: 0;
// //                 }
// //                 .info-label {
// //                     font-size: 11px;
// //                     color: #6b7280;
// //                     text-transform: uppercase;
// //                     letter-spacing: 0.5px;
// //                     margin-bottom: 2px;
// //                     font-weight: 600;
// //                 }
// //                 .info-value {
// //                     font-size: 14px;
// //                     color: #1a1a1a;
// //                     font-weight: 500;
// //                     line-height: 1.4;
// //                 }
// //                 .benefits-list { list-style: none; padding: 0; margin: 0; }
// //                 .benefits-list li {
// //                     display: flex;
// //                     align-items: flex-start;
// //                     gap: 10px;
// //                     padding: 10px 0;
// //                     border-bottom: 1px solid #f5f7fa;
// //                     font-size: 14px;
// //                     color: #4b5563;
// //                 }
// //                 .benefits-list li:last-child { border-bottom: none; }
// //                 .benefits-list .anticon {
// //                     color: #10b981;
// //                     font-size: 16px;
// //                     margin-top: 3px;
// //                     flex-shrink: 0;
// //                 }
// //                 @media (max-width: 768px) {
// //                     .hero-content { padding: 0 20px; }
// //                     .hero-title { font-size: 28px; }
// //                     .hero-desc { font-size: 15px; }
// //                     .content-section { padding: 0 20px 40px; }
// //                     .section-card { padding: 20px; }
// //                 }
// //             `}</style>

// //             <div className="hero">
// //                 <div className="hero-content">
// //                     <Link to="/live-trainings" className="back-button">
// //                         <ArrowLeftOutlined /> Retour aux formations
// //                     </Link>

// //                     <div className="hero-grid">
// //                         <div className="hero-info">
// //                             <div className="badges">
// //                                 <span className="live-tag">LIVE</span>
// //                                 {training.category?.libelle && (
// //                                     <span className="category-tag">{training.category.libelle}</span>
// //                                 )}
// //                                 {hasPurchased && (
// //                                     <span className="purchased-tag">
// //                                         <CheckCircleOutlined /> INSCRIT
// //                                     </span>
// //                                 )}
// //                             </div>

// //                             <h1 className="hero-title">{training.title}</h1>

// //                             {training.short_desc && (
// //                                 <p className="hero-desc">{training.short_desc}</p>
// //                             )}

// //                             <div className="hero-meta">
// //                                 <div className="hero-meta-item">
// //                                     <CalendarOutlined />
// //                                     <span>{formatLiveDate(training.liveDate)}</span>
// //                                 </div>
// //                                 {training.duration && (
// //                                     <div className="hero-meta-item">
// //                                         <ClockCircleOutlined />
// //                                         <span>{training.duration}</span>
// //                                     </div>
// //                                 )}
// //                             </div>
// //                         </div>

// //                         <div className={`countdown-card ${hasPurchased ? 'purchased' : ''}`}>
// //                             {training.image ? (
// //                                 <img src={training.image} alt={training.title} className="countdown-image" />
// //                             ) : (
// //                                 <div className="countdown-image-placeholder">
// //                                     <VideoCameraOutlined />
// //                                 </div>
// //                             )}

// //                             {!isPast && timeUntil && (
// //                                 <>
// //                                     <div className="countdown-title">⏱️ Démarrage dans</div>
// //                                     <div className="countdown-grid">
// //                                         <div className="countdown-cell">
// //                                             <div className="countdown-value">{timeUntil.days}</div>
// //                                             <div className="countdown-label">Jours</div>
// //                                         </div>
// //                                         <div className="countdown-cell">
// //                                             <div className="countdown-value">{timeUntil.hours}</div>
// //                                             <div className="countdown-label">Heures</div>
// //                                         </div>
// //                                         <div className="countdown-cell">
// //                                             <div className="countdown-value">{timeUntil.minutes}</div>
// //                                             <div className="countdown-label">Minutes</div>
// //                                         </div>
// //                                     </div>
// //                                 </>
// //                             )}

// //                             <div className="price-section">
// //                                 <div className="price-label">Prix de la formation</div>
// //                                 <div className="price-value">{training.price} €</div>
// //                             </div>

// //                             {isPast ? (
// //                                 <div className="past-badge">
// //                                     <ClockCircleOutlined /> Cette formation est terminée
// //                                 </div>
// //                             ) : hasPurchased ? (
// //                                 <>
// //                                     <div className="btn-purchased">
// //                                         <CheckCircleOutlined /> Vous êtes inscrit
// //                                     </div>
// //                                     {training.meetingLink && (
// //                                         <div className="meeting-link-box">
// //                                             🔗 <a href={training.meetingLink} target="_blank" rel="noopener noreferrer">
// //                                                 Rejoindre la session live
// //                                             </a>
// //                                         </div>
// //                                     )}
// //                                 </>
// //                             ) : (
// //                                 <button
// //                                     className="btn-subscribe"
// //                                     onClick={handleSubscribe}
// //                                     disabled={isProcessingPayment}
// //                                 >
// //                                     {isProcessingPayment ? (
// //                                         <><LoadingOutlined /> Traitement...</>
// //                                     ) : (
// //                                         <><PlayCircleOutlined /> S'inscrire à la formation</>
// //                                     )}
// //                                 </button>
// //                             )}
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>

// //             <div className="content-section">
// //                 <div className="content-grid">
// //                     <div className="main-content">
// //                         {training.overview && (
// //                             <div className="section-card">
// //                                 <div className="section-header">
// //                                     <div className="section-icon"><BulbOutlined /></div>
// //                                     <h2 className="section-title">À propos de cette formation</h2>
// //                                 </div>
// //                                 <div className="section-content" dangerouslySetInnerHTML={{ __html: training.overview }} />
// //                             </div>
// //                         )}

// //                         {training.what_you_will_learn && (
// //                             <div className="section-card">
// //                                 <div className="section-header">
// //                                     <div className="section-icon"><FireOutlined /></div>
// //                                     <h2 className="section-title">Ce que vous allez apprendre</h2>
// //                                 </div>
// //                                 <div className="section-content" dangerouslySetInnerHTML={{ __html: training.what_you_will_learn }} />
// //                             </div>
// //                         )}

// //                         {training.requirements && (
// //                             <div className="section-card">
// //                                 <div className="section-header">
// //                                     <div className="section-icon"><SafetyCertificateOutlined /></div>
// //                                     <h2 className="section-title">Prérequis</h2>
// //                                 </div>
// //                                 <div className="section-content" dangerouslySetInnerHTML={{ __html: training.requirements }} />
// //                             </div>
// //                         )}

// //                         {training.who_is_this_course_for && (
// //                             <div className="section-card">
// //                                 <div className="section-header">
// //                                     <div className="section-icon"><TeamOutlined /></div>
// //                                     <h2 className="section-title">Public cible</h2>
// //                                 </div>
// //                                 <div className="section-content" dangerouslySetInnerHTML={{ __html: training.who_is_this_course_for }} />
// //                             </div>
// //                         )}
// //                     </div>

// //                     <div className="sidebar">
// //                         <div className="info-card">
// //                             <h3 className="info-card-title">📋 Informations</h3>
// //                             <div className="info-list">
// //                                 <div className="info-item">
// //                                     <CalendarOutlined />
// //                                     <div>
// //                                         <div className="info-label">Date du live</div>
// //                                         <div className="info-value">{formatLiveDate(training.liveDate)}</div>
// //                                     </div>
// //                                 </div>
// //                                 {training.duration && (
// //                                     <div className="info-item">
// //                                         <ClockCircleOutlined />
// //                                         <div>
// //                                             <div className="info-label">Durée</div>
// //                                             <div className="info-value">{training.duration}</div>
// //                                         </div>
// //                                     </div>
// //                                 )}
// //                                 <div className="info-item">
// //                                     <DollarOutlined />
// //                                     <div>
// //                                         <div className="info-label">Prix</div>
// //                                         <div className="info-value">{training.price} €</div>
// //                                     </div>
// //                                 </div>
// //                                 {training.category?.libelle && (
// //                                     <div className="info-item">
// //                                         <TagsOutlined />
// //                                         <div>
// //                                             <div className="info-label">Catégorie</div>
// //                                             <div className="info-value">{training.category.libelle}</div>
// //                                         </div>
// //                                     </div>
// //                                 )}
// //                             </div>
// //                         </div>

// //                         <div className="info-card">
// //                             <h3 className="info-card-title">✨ Avantages inclus</h3>
// //                             <ul className="benefits-list">
// //                                 <li><CheckCircleOutlined /><span>Session live interactive</span></li>
// //                                 <li><CheckCircleOutlined /><span>Q&A en direct</span></li>
// //                                 <li><CheckCircleOutlined /><span>Lien meeting par email</span></li>
// //                                 <li><CheckCircleOutlined /><span>Replay disponible</span></li>
// //                                 <li><CheckCircleOutlined /><span>Support 7 jours</span></li>
// //                             </ul>
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>

// //             <Modal
// //                 title="Connectez-vous pour vous inscrire"
// //                 open={showLoginModal}
// //                 onCancel={() => setShowLoginModal(false)}
// //                 footer={null}
// //                 centered
// //             >
// //                 <p>Pour vous inscrire à cette formation live, vous devez être connecté à votre compte.</p>
// //                 <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
// //                     <button
// //                         onClick={() => navigate("/login")}
// //                         style={{
// //                             flex: 1, padding: 12,
// //                             background: 'linear-gradient(135deg, #ee5a6f 0%, #ff6b6b 100%)',
// //                             color: 'white', border: 'none', borderRadius: 8,
// //                             fontWeight: 600, cursor: 'pointer',
// //                             display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
// //                         }}
// //                     >
// //                         <LoginOutlined /> Se connecter
// //                     </button>
// //                     <button
// //                         onClick={() => navigate("/register")}
// //                         style={{
// //                             flex: 1, padding: 12,
// //                             background: 'white', color: '#ee5a6f',
// //                             border: '2px solid #ee5a6f', borderRadius: 8,
// //                             fontWeight: 600, cursor: 'pointer',
// //                             display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
// //                         }}
// //                     >
// //                         <UserOutlined /> Créer un compte
// //                     </button>
// //                 </div>
// //             </Modal>

// //         </div>
// //     );
// // };

// // export default LiveTrainingDetails;



// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate, Link } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { Spin, message, Modal } from "antd";
// import {
//     VideoCameraOutlined,
//     CalendarOutlined,
//     ClockCircleOutlined,
//     DollarOutlined,
//     ArrowLeftOutlined,
//     CheckCircleOutlined,
//     UserOutlined,
//     TagsOutlined,
//     PlayCircleOutlined,
//     LoginOutlined,
//     SafetyCertificateOutlined,
//     TeamOutlined,
//     FireOutlined,
//     BulbOutlined,
//     LoadingOutlined,
// } from "@ant-design/icons";
// import dayjs from "dayjs";
// import liveTrainingService from "../../../services/liveTraining.service";

// // 🎨 COULEURS NOMIDYA
// const C = {
//     blue: "#0054A6",
//     blueDark: "#003B75",
//     blueDeep: "#002147",
//     orange: "#E8860C",
//     orangeLight: "#FF8C00",
//     orangeDark: "#C46F0A",
// };

// const LiveTrainingDetails = () => {
//     const { id } = useParams();
//     const navigate = useNavigate();
//     const { user: currentUser } = useSelector((state) => state.auth);

//     const [training, setTraining] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [showLoginModal, setShowLoginModal] = useState(false);
//     const [hasPurchased, setHasPurchased] = useState(false);
//     const [isProcessingPayment, setIsProcessingPayment] = useState(false);

//     useEffect(() => {
//         const fetchTraining = async () => {
//             try {
//                 setLoading(true);
//                 const data = await liveTrainingService.getById(id);
//                 setTraining(data);

//                 if (currentUser?.id) {
//                     const checkResult = await liveTrainingService.checkPurchase(currentUser.id, id);
//                     setHasPurchased(checkResult.hasPurchased);
//                 }
//             } catch (error) {
//                 console.error("Erreur:", error);
//                 message.error("Formation introuvable");
//                 navigate("/live-trainings");
//             } finally {
//                 setLoading(false);
//             }
//         };
//         if (id) fetchTraining();
//     }, [id, navigate, currentUser?.id]);

//     const handleSubscribe = () => {
//         if (!currentUser) {
//             setShowLoginModal(true);
//             return;
//         }

//         if (hasPurchased) {
//             message.info("Vous êtes déjà inscrit à cette formation !");
//             return;
//         }

//         navigate(`/pay/live-training/${training.id}`);
//     };

//     const formatLiveDate = (date) => {
//         if (!date) return "Date à venir";
//         return dayjs(date).format("dddd DD MMMM YYYY • HH:mm");
//     };

//     const getTimeUntil = (date) => {
//         if (!date) return null;
//         const target = dayjs(date);
//         const now = dayjs();
//         if (target.isBefore(now)) return { passed: true };

//         const days = target.diff(now, "day");
//         const hours = target.diff(now, "hour") % 24;
//         const minutes = target.diff(now, "minute") % 60;

//         return { passed: false, days, hours, minutes };
//     };

//     const timeUntil = training ? getTimeUntil(training.liveDate) : null;
//     const isPast = timeUntil?.passed;

//    if (loading) {
//     return (
//         <div style={{
//             minHeight: '60vh',
//             background: '#f7f8fa',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             padding: '40px 20px',
//         }}>
//             <style>{`
//                 @keyframes nomidya-pulse {
//                     0%, 100% { transform: scale(1); opacity: 1; }
//                     50% { transform: scale(1.1); opacity: 0.7; }
//                 }

//                 @keyframes nomidya-rotate {
//                     0% { transform: rotate(0deg); }
//                     100% { transform: rotate(360deg); }
//                 }

//                 @keyframes nomidya-fade-in {
//                     from { opacity: 0; transform: translateY(20px); }
//                     to { opacity: 1; transform: translateY(0); }
//                 }

//                 @keyframes nomidya-bounce {
//                     0%, 100% { transform: translateY(0); }
//                     50% { transform: translateY(-12px); }
//                 }

//                 .nomidya-loader-card {
//                     background: white;
//                     border-radius: 24px;
//                     padding: 60px 50px;
//                     box-shadow: 0 25px 50px rgba(0, 84, 166, 0.12);
//                     text-align: center;
//                     max-width: 500px;
//                     width: 100%;
//                     animation: nomidya-fade-in 0.6s ease-out;
//                     border: 1px solid rgba(0, 84, 166, 0.08);
//                 }

//                 .nomidya-loader-icon-wrapper {
//                     position: relative;
//                     width: 100px;
//                     height: 100px;
//                     margin: 0 auto 32px;
//                 }

//                 .nomidya-loader-ring {
//                     position: absolute;
//                     top: 0;
//                     left: 0;
//                     width: 100px;
//                     height: 100px;
//                     border-radius: 50%;
//                     border: 4px solid transparent;
//                     border-top-color: ${C.blue};
//                     border-right-color: ${C.orange};
//                     animation: nomidya-rotate 1.2s linear infinite;
//                 }

//                 .nomidya-loader-ring-2 {
//                     position: absolute;
//                     top: 10px;
//                     left: 10px;
//                     width: 80px;
//                     height: 80px;
//                     border-radius: 50%;
//                     border: 3px solid transparent;
//                     border-bottom-color: ${C.blueDark};
//                     border-left-color: ${C.orangeLight};
//                     animation: nomidya-rotate 1.5s linear infinite reverse;
//                 }

//                 .nomidya-loader-center {
//                     position: absolute;
//                     top: 50%;
//                     left: 50%;
//                     transform: translate(-50%, -50%);
//                     width: 50px;
//                     height: 50px;
//                     background: linear-gradient(135deg, ${C.blue} 0%, ${C.orange} 100%);
//                     border-radius: 12px;
//                     display: flex;
//                     align-items: center;
//                     justify-content: center;
//                     color: white;
//                     font-size: 24px;
//                     animation: nomidya-pulse 2s ease-in-out infinite;
//                     box-shadow: 0 8px 24px rgba(0, 84, 166, 0.3);
//                 }

//                 .nomidya-loader-title {
//                     font-size: 22px;
//                     font-weight: 700;
//                     color: ${C.blueDark};
//                     margin: 0 0 8px;
//                     letter-spacing: -0.3px;
//                 }

//                 .nomidya-loader-subtitle {
//                     font-size: 14px;
//                     color: #6b7280;
//                     margin: 0 0 24px;
//                     line-height: 1.6;
//                 }

//                 .nomidya-loader-dots {
//                     display: flex;
//                     justify-content: center;
//                     gap: 10px;
//                     margin-top: 20px;
//                 }

//                 .nomidya-loader-dot {
//                     width: 10px;
//                     height: 10px;
//                     border-radius: 50%;
//                     animation: nomidya-bounce 1.4s ease-in-out infinite;
//                 }

//                 .nomidya-loader-dot:nth-child(1) {
//                     background: ${C.blue};
//                     animation-delay: 0s;
//                 }

//                 .nomidya-loader-dot:nth-child(2) {
//                     background: ${C.orange};
//                     animation-delay: 0.2s;
//                 }

//                 .nomidya-loader-dot:nth-child(3) {
//                     background: ${C.blueDark};
//                     animation-delay: 0.4s;
//                 }

//                 .nomidya-loader-progress {
//                     width: 100%;
//                     height: 4px;
//                     background: #e8eef5;
//                     border-radius: 4px;
//                     overflow: hidden;
//                     margin-top: 24px;
//                 }

//                 .nomidya-loader-progress-bar {
//                     height: 100%;
//                     background: linear-gradient(90deg, ${C.blue} 0%, ${C.orange} 100%);
//                     border-radius: 4px;
//                     width: 30%;
//                     animation: nomidya-progress 2s ease-in-out infinite;
//                 }

//                 @keyframes nomidya-progress {
//                     0% { width: 0%; margin-left: 0%; }
//                     50% { width: 70%; margin-left: 15%; }
//                     100% { width: 0%; margin-left: 100%; }
//                 }
//             `}</style>

//             <div className="nomidya-loader-card">
//                 <div className="nomidya-loader-icon-wrapper">
//                     <div className="nomidya-loader-ring"></div>
//                     <div className="nomidya-loader-ring-2"></div>
//                     <div className="nomidya-loader-center">
//                         <VideoCameraOutlined />
//                     </div>
//                 </div>

//                 <h2 className="nomidya-loader-title">
//                     Chargement de la formation
//                 </h2>

//                 <p className="nomidya-loader-subtitle">
//                     Préparation des détails et informations...
//                 </p>

//                 <div className="nomidya-loader-dots">
//                     <div className="nomidya-loader-dot"></div>
//                     <div className="nomidya-loader-dot"></div>
//                     <div className="nomidya-loader-dot"></div>
//                 </div>

//                 <div className="nomidya-loader-progress">
//                     <div className="nomidya-loader-progress-bar"></div>
//                 </div>
//             </div>
//         </div>
//     );
// }

//     if (!training) return null;

//     return (
//         <div className="details-container">
//             <style>{`
//                 .details-container { min-height: 100vh; background: #f8f9fa; }

//                 /* HERO BLEU NOMIDYA */
//                 .hero {
//                     background: linear-gradient(135deg, ${C.blueDeep} 0%, ${C.blueDark} 50%, ${C.blue} 100%);
//                     padding: 32px 0 60px;
//                     color: white;
//                     position: relative;
//                     overflow: hidden;
//                 }
//                 .hero::before {
//                     content: '';
//                     position: absolute;
//                     top: 0; left: 0;
//                     width: 100%; height: 100%;
//                     background-image:
//                         radial-gradient(circle at 20% 50%, rgba(232,134,12,0.15) 0%, transparent 50%),
//                         radial-gradient(circle at 80% 80%, rgba(255,255,255,0.08) 0%, transparent 50%);
//                 }
//                 .hero-content {
//                     max-width: 1200px;
//                     margin: 0 auto;
//                     padding: 0 32px;
//                     position: relative;
//                     z-index: 1;
//                 }
//                 .back-button {
//                     display: inline-flex;
//                     align-items: center;
//                     gap: 8px;
//                     color: rgba(255,255,255,0.9);
//                     background: rgba(255,255,255,0.15);
//                     backdrop-filter: blur(10px);
//                     padding: 8px 18px;
//                     border-radius: 30px;
//                     text-decoration: none;
//                     font-size: 14px;
//                     font-weight: 500;
//                     transition: all 0.2s;
//                     margin-bottom: 24px;
//                     border: 1px solid rgba(255,255,255,0.2);
//                 }
//                 .back-button:hover {
//                     background: rgba(255,255,255,0.25);
//                     color: white;
//                     transform: translateX(-4px);
//                 }
//                 .hero-grid {
//                     display: grid;
//                     grid-template-columns: 1.5fr 1fr;
//                     gap: 40px;
//                     align-items: start;
//                 }
//                 @media (max-width: 1024px) { .hero-grid { grid-template-columns: 1fr; } }

//                 .hero-info .badges {
//                     display: flex;
//                     gap: 8px;
//                     margin-bottom: 16px;
//                     flex-wrap: wrap;
//                 }

//                 /* Badge LIVE - GARDÉ EN ROUGE */
//                 .live-tag {
//                     background: rgba(255,0,0,0.95);
//                     color: white;
//                     padding: 6px 14px;
//                     border-radius: 20px;
//                     font-size: 11px;
//                     font-weight: 700;
//                     letter-spacing: 1.5px;
//                     display: inline-flex;
//                     align-items: center;
//                     gap: 6px;
//                     box-shadow: 0 4px 12px rgba(0,0,0,0.2);
//                 }
//                 .live-tag::before {
//                     content: '';
//                     width: 8px; height: 8px;
//                     background: white;
//                     border-radius: 50%;
//                     animation: pulse 1.5s infinite;
//                 }
//                 @keyframes pulse {
//                     0%, 100% { opacity: 1; }
//                     50% { opacity: 0.4; }
//                 }

//                 /* Catégorie - ORANGE Nomidya */
//                 .category-tag {
//                     background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%);
//                     color: white;
//                     padding: 6px 14px;
//                     border-radius: 20px;
//                     font-size: 12px;
//                     font-weight: 700;
//                     text-transform: uppercase;
//                     letter-spacing: 1px;
//                     box-shadow: 0 4px 12px rgba(232,134,12,0.3);
//                 }

//                 /* Badge INSCRIT - VERT (gardé pour succès) */
//                 .purchased-tag {
//                     background: rgba(82,196,26,0.95);
//                     color: white;
//                     padding: 6px 14px;
//                     border-radius: 20px;
//                     font-size: 12px;
//                     font-weight: 700;
//                     display: inline-flex;
//                     align-items: center;
//                     gap: 6px;
//                     box-shadow: 0 4px 12px rgba(0,0,0,0.2);
//                 }

//                 .hero-title {
//                     font-size: 42px;
//                     font-weight: 800;
//                     line-height: 1.15;
//                     margin: 0 0 16px;
//                     text-shadow: 0 2px 10px rgba(0,0,0,0.2);
//                 }

//                 .hero-desc {
//                     font-size: 17px;
//                     line-height: 1.6;
//                     opacity: 0.95;
//                     margin-bottom: 24px;
//                 }

//                 .hero-meta {
//                     display: flex;
//                     gap: 24px;
//                     flex-wrap: wrap;
//                     font-size: 14px;
//                 }

//                 .hero-meta-item {
//                     display: flex;
//                     align-items: center;
//                     gap: 8px;
//                     color: rgba(255,255,255,0.95);
//                 }

//                 /* CARTE COMPTE À REBOURS - BLEUE NOMIDYA */
//                 .countdown-card {
//                     background: white;
//                     border-radius: 20px;
//                     padding: 24px;
//                     box-shadow: 0 10px 40px rgba(0,33,71,0.25);
//                     color: #1a1a1a;
//                 }
//                 .countdown-card.purchased { border: 3px solid #52c41a; }

//                 .countdown-image {
//                     width: 100%;
//                     height: 220px;
//                     border-radius: 12px;
//                     object-fit: cover;
//                     margin-bottom: 20px;
//                 }
//                 .countdown-image-placeholder {
//                     width: 100%;
//                     height: 220px;
//                     border-radius: 12px;
//                     background: linear-gradient(135deg, ${C.blueDark} 0%, ${C.blue} 100%);
//                     display: flex;
//                     align-items: center;
//                     justify-content: center;
//                     color: white;
//                     font-size: 80px;
//                     margin-bottom: 20px;
//                 }

//                 .countdown-title {
//                     font-size: 13px;
//                     text-transform: uppercase;
//                     letter-spacing: 1px;
//                     color: #6b7280;
//                     margin-bottom: 12px;
//                     text-align: center;
//                     font-weight: 600;
//                 }

//                 .countdown-grid {
//                     display: grid;
//                     grid-template-columns: repeat(3, 1fr);
//                     gap: 8px;
//                     margin-bottom: 20px;
//                 }

//                 /* CELLULES BLEUES */
//                 .countdown-cell {
//                     background: linear-gradient(135deg, #f0f7ff 0%, #e6f0ff 100%);
//                     border-radius: 12px;
//                     padding: 16px 8px;
//                     text-align: center;
//                     border: 1px solid ${C.blue}33;
//                 }

//                 .countdown-value {
//                     font-size: 32px;
//                     font-weight: 800;
//                     color: ${C.blue};
//                     line-height: 1;
//                 }

//                 .countdown-label {
//                     font-size: 11px;
//                     text-transform: uppercase;
//                     color: #6b7280;
//                     margin-top: 4px;
//                     font-weight: 600;
//                     letter-spacing: 0.5px;
//                 }

//                 /* PRIX - ORANGE Nomidya */
//                 .price-section {
//                     background: linear-gradient(135deg, ${C.orange}11 0%, ${C.orangeLight}22 100%);
//                     border: 2px solid ${C.orange}44;
//                     padding: 16px;
//                     border-radius: 12px;
//                     text-align: center;
//                     margin-bottom: 16px;
//                 }

//                 .price-label {
//                     font-size: 12px;
//                     color: ${C.blueDark};
//                     text-transform: uppercase;
//                     letter-spacing: 1px;
//                     font-weight: 600;
//                 }

//                 .price-value {
//                     font-size: 36px;
//                     font-weight: 800;
//                     color: ${C.orange};
//                     line-height: 1;
//                     margin-top: 4px;
//                 }

//                 /* BOUTON S'INSCRIRE - ORANGE NOMIDYA (CTA) */
//                 .btn-subscribe {
//                     width: 100%;
//                     padding: 16px;
//                     background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%);
//                     color: white;
//                     border: none;
//                     border-radius: 12px;
//                     font-size: 16px;
//                     font-weight: 700;
//                     cursor: pointer;
//                     display: flex;
//                     align-items: center;
//                     justify-content: center;
//                     gap: 10px;
//                     box-shadow: 0 8px 24px rgba(232,134,12,0.4);
//                     transition: all 0.3s;
//                     text-transform: uppercase;
//                     letter-spacing: 1px;
//                 }
//                 .btn-subscribe:hover:not(:disabled) {
//                     transform: translateY(-2px);
//                     box-shadow: 0 12px 32px rgba(232,134,12,0.5);
//                     background: linear-gradient(135deg, ${C.orangeDark} 0%, ${C.orange} 100%);
//                 }
//                 .btn-subscribe:disabled { opacity: 0.6; cursor: not-allowed; }

//                 /* BOUTON INSCRIT - VERT (gardé) */
//                 .btn-purchased {
//                     width: 100%;
//                     padding: 16px;
//                     background: linear-gradient(135deg, #52c41a 0%, #389e0d 100%);
//                     color: white;
//                     border: none;
//                     border-radius: 12px;
//                     font-size: 16px;
//                     font-weight: 700;
//                     cursor: default;
//                     display: flex;
//                     align-items: center;
//                     justify-content: center;
//                     gap: 10px;
//                     box-shadow: 0 8px 24px rgba(82,196,26,0.4);
//                     text-transform: uppercase;
//                     letter-spacing: 1px;
//                 }

//                 .past-badge {
//                     background: #f3f4f6;
//                     color: #6b7280;
//                     padding: 14px;
//                     border-radius: 12px;
//                     text-align: center;
//                     font-weight: 600;
//                     border: 2px dashed #d1d5db;
//                 }

//                 .meeting-link-box {
//                     background: #f6ffed;
//                     border: 1px solid #b7eb8f;
//                     padding: 12px;
//                     border-radius: 8px;
//                     margin-top: 12px;
//                     text-align: center;
//                 }
//                 .meeting-link-box a {
//                     color: #389e0d;
//                     font-weight: 600;
//                     text-decoration: none;
//                 }

//                 /* CONTENT */
//                 .content-section {
//                     max-width: 1200px;
//                     margin: -40px auto 0;
//                     padding: 0 32px 60px;
//                     position: relative;
//                     z-index: 2;
//                 }

//                 .content-grid {
//                     display: grid;
//                     grid-template-columns: 1fr 320px;
//                     gap: 32px;
//                 }

//                 @media (max-width: 1024px) { .content-grid { grid-template-columns: 1fr; } }

//                 .main-content { display: flex; flex-direction: column; gap: 24px; }

//                 .section-card {
//                     background: white;
//                     border-radius: 20px;
//                     padding: 28px;
//                     box-shadow: 0 4px 16px rgba(0,84,166,0.06);
//                     border: 1px solid #f0f0f0;
//                 }

//                 .section-header {
//                     display: flex;
//                     align-items: center;
//                     gap: 12px;
//                     margin-bottom: 16px;
//                     padding-bottom: 16px;
//                     border-bottom: 2px solid #f0f7ff;
//                 }

//                 /* ICÔNES SECTIONS - BLEU NOMIDYA */
//                 .section-icon {
//                     width: 40px;
//                     height: 40px;
//                     border-radius: 12px;
//                     display: flex;
//                     align-items: center;
//                     justify-content: center;
//                     color: white;
//                     font-size: 18px;
//                     background: linear-gradient(135deg, ${C.blueDark} 0%, ${C.blue} 100%);
//                 }

//                 /* ICÔNE SECTION CONTENU - ORANGE (différenciation) */
//                 .section-icon.orange {
//                     background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%);
//                 }

//                 .section-title {
//                     margin: 0;
//                     font-size: 20px;
//                     font-weight: 700;
//                     color: #1a1a1a;
//                 }

//                 .section-content {
//                     color: #4b5563;
//                     line-height: 1.8;
//                     font-size: 15px;
//                 }

//                 /* SIDEBAR */
//                 .sidebar {
//                     display: flex;
//                     flex-direction: column;
//                     gap: 16px;
//                     position: sticky;
//                     top: 80px;
//                     height: fit-content;
//                 }

//                 @media (max-width: 1024px) { .sidebar { position: static; } }

//                 .info-card {
//                     background: white;
//                     border-radius: 16px;
//                     padding: 20px;
//                     box-shadow: 0 4px 16px rgba(0,84,166,0.06);
//                     border: 1px solid #f0f0f0;
//                 }

//                 .info-card-title {
//                     font-size: 12px;
//                     color: ${C.blueDark};
//                     text-transform: uppercase;
//                     letter-spacing: 1px;
//                     font-weight: 700;
//                     margin: 0 0 12px;
//                     border-bottom: 2px solid #f0f7ff;
//                     padding-bottom: 8px;
//                 }

//                 .info-list { display: flex; flex-direction: column; gap: 12px; }
//                 .info-item { display: flex; align-items: flex-start; gap: 10px; padding: 8px 0; }

//                 /* Icônes info - BLEU */
//                 .info-item .anticon {
//                     color: ${C.blue};
//                     font-size: 18px;
//                     margin-top: 2px;
//                     flex-shrink: 0;
//                 }

//                 .info-label {
//                     font-size: 11px;
//                     color: #6b7280;
//                     text-transform: uppercase;
//                     letter-spacing: 0.5px;
//                     margin-bottom: 2px;
//                     font-weight: 600;
//                 }

//                 .info-value {
//                     font-size: 14px;
//                     color: #1a1a1a;
//                     font-weight: 500;
//                     line-height: 1.4;
//                 }

//                 /* Avantages inclus - card avec accent ORANGE */
//                 .benefits-card {
//                     background: linear-gradient(135deg, ${C.orange}08 0%, ${C.orangeLight}11 100%);
//                     border: 1px solid ${C.orange}33;
//                 }

//                 .benefits-card .info-card-title {
//                     color: ${C.orange};
//                     border-bottom-color: ${C.orange}33;
//                 }

//                 .benefits-list { list-style: none; padding: 0; margin: 0; }
//                 .benefits-list li {
//                     display: flex;
//                     align-items: flex-start;
//                     gap: 10px;
//                     padding: 10px 0;
//                     border-bottom: 1px solid #f5f7fa;
//                     font-size: 14px;
//                     color: #4b5563;
//                 }
//                 .benefits-list li:last-child { border-bottom: none; }
//                 .benefits-list .anticon {
//                     color: #10b981;
//                     font-size: 16px;
//                     margin-top: 3px;
//                     flex-shrink: 0;
//                 }

//                 @media (max-width: 768px) {
//                     .hero-content { padding: 0 20px; }
//                     .hero-title { font-size: 28px; }
//                     .hero-desc { font-size: 15px; }
//                     .content-section { padding: 0 20px 40px; }
//                     .section-card { padding: 20px; }
//                 }
//             `}</style>

//             <div className="hero">
//                 <div className="hero-content">
//                     <Link to="/live-trainings" className="back-button">
//                         <ArrowLeftOutlined /> Retour aux formations
//                     </Link>

//                     <div className="hero-grid">
//                         <div className="hero-info">
//                             <div className="badges">
//                                 <span className="live-tag">LIVE</span>
//                                 {training.category?.libelle && (
//                                     <span className="category-tag">{training.category.libelle}</span>
//                                 )}
//                                 {hasPurchased && (
//                                     <span className="purchased-tag">
//                                         <CheckCircleOutlined /> INSCRIT
//                                     </span>
//                                 )}
//                             </div>

//                             <h1 className="hero-title">{training.title}</h1>

//                             {training.short_desc && (
//                                 <p className="hero-desc">{training.short_desc}</p>
//                             )}

//                             <div className="hero-meta">
//                                 <div className="hero-meta-item">
//                                     <CalendarOutlined />
//                                     <span>{formatLiveDate(training.liveDate)}</span>
//                                 </div>
//                                 {training.duration && (
//                                     <div className="hero-meta-item">
//                                         <ClockCircleOutlined />
//                                         <span>{training.duration}</span>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>

//                         <div className={`countdown-card ${hasPurchased ? 'purchased' : ''}`}>
//                             {training.image ? (
//                                 <img src={training.image} alt={training.title} className="countdown-image" />
//                             ) : (
//                                 <div className="countdown-image-placeholder">
//                                     <VideoCameraOutlined />
//                                 </div>
//                             )}

//                             {!isPast && timeUntil && (
//                                 <>
//                                     <div className="countdown-title">⏱️ Démarrage dans</div>
//                                     <div className="countdown-grid">
//                                         <div className="countdown-cell">
//                                             <div className="countdown-value">{timeUntil.days}</div>
//                                             <div className="countdown-label">Jours</div>
//                                         </div>
//                                         <div className="countdown-cell">
//                                             <div className="countdown-value">{timeUntil.hours}</div>
//                                             <div className="countdown-label">Heures</div>
//                                         </div>
//                                         <div className="countdown-cell">
//                                             <div className="countdown-value">{timeUntil.minutes}</div>
//                                             <div className="countdown-label">Minutes</div>
//                                         </div>
//                                     </div>
//                                 </>
//                             )}

//                             <div className="price-section">
//                                 <div className="price-label">Prix de la formation</div>
//                                 <div className="price-value">{training.price} €</div>
//                             </div>

//                             {isPast ? (
//                                 <div className="past-badge">
//                                     <ClockCircleOutlined /> Cette formation est terminée
//                                 </div>
//                             ) : hasPurchased ? (
//                                 <>
//                                     <div className="btn-purchased">
//                                         <CheckCircleOutlined /> Vous êtes inscrit
//                                     </div>
//                                     {training.meetingLink && (
//                                         <div className="meeting-link-box">
//                                             🔗 <a href={training.meetingLink} target="_blank" rel="noopener noreferrer">
//                                                 Rejoindre la session live
//                                             </a>
//                                         </div>
//                                     )}
//                                 </>
//                             ) : (
//                                 <button
//                                     className="btn-subscribe"
//                                     onClick={handleSubscribe}
//                                     disabled={isProcessingPayment}
//                                 >
//                                     {isProcessingPayment ? (
//                                         <><LoadingOutlined /> Traitement...</>
//                                     ) : (
//                                         <><PlayCircleOutlined /> S'inscrire à la formation</>
//                                     )}
//                                 </button>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <div className="content-section">
//                 <div className="content-grid">
//                     <div className="main-content">
//                         {training.overview && (
//                             <div className="section-card">
//                                 <div className="section-header">
//                                     <div className="section-icon"><BulbOutlined /></div>
//                                     <h2 className="section-title">À propos de cette formation</h2>
//                                 </div>
//                                 <div className="section-content" dangerouslySetInnerHTML={{ __html: training.overview }} />
//                             </div>
//                         )}

//                         {training.what_you_will_learn && (
//                             <div className="section-card">
//                                 <div className="section-header">
//                                     <div className="section-icon orange"><FireOutlined /></div>
//                                     <h2 className="section-title">Ce que vous allez apprendre</h2>
//                                 </div>
//                                 <div className="section-content" dangerouslySetInnerHTML={{ __html: training.what_you_will_learn }} />
//                             </div>
//                         )}

//                         {training.requirements && (
//                             <div className="section-card">
//                                 <div className="section-header">
//                                     <div className="section-icon"><SafetyCertificateOutlined /></div>
//                                     <h2 className="section-title">Prérequis</h2>
//                                 </div>
//                                 <div className="section-content" dangerouslySetInnerHTML={{ __html: training.requirements }} />
//                             </div>
//                         )}

//                         {training.who_is_this_course_for && (
//                             <div className="section-card">
//                                 <div className="section-header">
//                                     <div className="section-icon"><TeamOutlined /></div>
//                                     <h2 className="section-title">Public cible</h2>
//                                 </div>
//                                 <div className="section-content" dangerouslySetInnerHTML={{ __html: training.who_is_this_course_for }} />
//                             </div>
//                         )}
//                     </div>

//                     <div className="sidebar">
//                         <div className="info-card">
//                             <h3 className="info-card-title">📋 Informations</h3>
//                             <div className="info-list">
//                                 <div className="info-item">
//                                     <CalendarOutlined />
//                                     <div>
//                                         <div className="info-label">Date du live</div>
//                                         <div className="info-value">{formatLiveDate(training.liveDate)}</div>
//                                     </div>
//                                 </div>
//                                 {training.duration && (
//                                     <div className="info-item">
//                                         <ClockCircleOutlined />
//                                         <div>
//                                             <div className="info-label">Durée</div>
//                                             <div className="info-value">{training.duration}</div>
//                                         </div>
//                                     </div>
//                                 )}
//                                 <div className="info-item">
//                                     <DollarOutlined />
//                                     <div>
//                                         <div className="info-label">Prix</div>
//                                         <div className="info-value">{training.price} €</div>
//                                     </div>
//                                 </div>
//                                 {training.category?.libelle && (
//                                     <div className="info-item">
//                                         <TagsOutlined />
//                                         <div>
//                                             <div className="info-label">Catégorie</div>
//                                             <div className="info-value">{training.category.libelle}</div>
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>

//                         <div className="info-card benefits-card">
//                             <h3 className="info-card-title">✨ Avantages inclus</h3>
//                             <ul className="benefits-list">
//                                 <li><CheckCircleOutlined /><span>Session live interactive</span></li>
//                                 <li><CheckCircleOutlined /><span>Q&A en direct</span></li>
//                                 <li><CheckCircleOutlined /><span>Lien meeting par email</span></li>
//                                 <li><CheckCircleOutlined /><span>Replay disponible</span></li>
//                                 <li><CheckCircleOutlined /><span>Support 7 jours</span></li>
//                             </ul>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <Modal
//                 title="Connectez-vous pour vous inscrire"
//                 open={showLoginModal}
//                 onCancel={() => setShowLoginModal(false)}
//                 footer={null}
//                 centered
//             >
//                 <p>Pour vous inscrire à cette formation live, vous devez être connecté à votre compte.</p>
//                 <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
//                     <button
//                         onClick={() => navigate("/login")}
//                         style={{
//                             flex: 1, padding: 12,
//                             background: `linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%)`,
//                             color: 'white', border: 'none', borderRadius: 8,
//                             fontWeight: 600, cursor: 'pointer',
//                             display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
//                         }}
//                     >
//                         <LoginOutlined /> Se connecter
//                     </button>
//                     <button
//                         onClick={() => navigate("/register")}
//                         style={{
//                             flex: 1, padding: 12,
//                             background: 'white', color: C.blue,
//                             border: `2px solid ${C.blue}`, borderRadius: 8,
//                             fontWeight: 600, cursor: 'pointer',
//                             display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
//                         }}
//                     >
//                         <UserOutlined /> Créer un compte
//                     </button>
//                 </div>
//             </Modal>

//         </div>
//     );
// };

// export default LiveTrainingDetails;



import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { message, Modal } from "antd";
import {
    VideoCameraOutlined,
    ClockCircleOutlined,
    DollarOutlined,
    ArrowLeftOutlined,
    CheckCircleOutlined,
    UserOutlined,
    TagsOutlined,
    PlayCircleOutlined,
    LoginOutlined,
    SafetyCertificateOutlined,
    TeamOutlined,
    FireOutlined,
    BulbOutlined,
    LoadingOutlined,
} from "@ant-design/icons";
import liveTrainingService from "../../../services/liveTraining.service";

// 🎨 COULEURS NOMIDYA
const C = {
    blue: "#0054A6",
    blueDark: "#003B75",
    blueDeep: "#002147",
    orange: "#E8860C",
    orangeLight: "#FF8C00",
    orangeDark: "#C46F0A",
};

const LiveTrainingDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { user: currentUser } = useSelector((state) => state.auth);

    const [training, setTraining] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [hasPurchased, setHasPurchased] = useState(false);
    const [isProcessingPayment, setIsProcessingPayment] = useState(false);

    useEffect(() => {
        const fetchTraining = async () => {
            try {
                setLoading(true);
                const data = await liveTrainingService.getById(id);
                setTraining(data);

                if (currentUser?.id) {
                    const checkResult = await liveTrainingService.checkPurchase(currentUser.id, id);
                    setHasPurchased(checkResult.hasPurchased);
                }
            } catch (error) {
                console.error("Erreur:", error);
                message.error("Formation introuvable");
                navigate("/live-trainings");
            } finally {
                setLoading(false);
            }
        };
        if (id) fetchTraining();
    }, [id, navigate, currentUser?.id]);

    const handleSubscribe = () => {
        if (!currentUser) {
            setShowLoginModal(true);
            return;
        }

        if (hasPurchased) {
            message.info("Vous êtes déjà inscrit à cette formation !");
            return;
        }

        navigate(`/pay/live-training/${training.id}`);
    };

    if (loading) {
        return (
            <div style={{
                minHeight: '60vh',
                background: '#f7f8fa',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '40px 20px',
            }}>
                <style>{`
                    @keyframes nomidya-pulse {
                        0%, 100% { transform: scale(1); opacity: 1; }
                        50% { transform: scale(1.1); opacity: 0.7; }
                    }
                    @keyframes nomidya-rotate {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                    @keyframes nomidya-fade-in {
                        from { opacity: 0; transform: translateY(20px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                    @keyframes nomidya-bounce {
                        0%, 100% { transform: translateY(0); }
                        50% { transform: translateY(-12px); }
                    }
                    @keyframes nomidya-progress {
                        0% { width: 0%; margin-left: 0%; }
                        50% { width: 70%; margin-left: 15%; }
                        100% { width: 0%; margin-left: 100%; }
                    }
                    .nomidya-loader-card {
                        background: white;
                        border-radius: 24px;
                        padding: 60px 50px;
                        box-shadow: 0 25px 50px rgba(0, 84, 166, 0.12);
                        text-align: center;
                        max-width: 500px;
                        width: 100%;
                        animation: nomidya-fade-in 0.6s ease-out;
                        border: 1px solid rgba(0, 84, 166, 0.08);
                    }
                    .nomidya-loader-icon-wrapper {
                        position: relative;
                        width: 100px;
                        height: 100px;
                        margin: 0 auto 32px;
                    }
                    .nomidya-loader-ring {
                        position: absolute;
                        top: 0; left: 0;
                        width: 100px; height: 100px;
                        border-radius: 50%;
                        border: 4px solid transparent;
                        border-top-color: ${C.blue};
                        border-right-color: ${C.orange};
                        animation: nomidya-rotate 1.2s linear infinite;
                    }
                    .nomidya-loader-ring-2 {
                        position: absolute;
                        top: 10px; left: 10px;
                        width: 80px; height: 80px;
                        border-radius: 50%;
                        border: 3px solid transparent;
                        border-bottom-color: ${C.blueDark};
                        border-left-color: ${C.orangeLight};
                        animation: nomidya-rotate 1.5s linear infinite reverse;
                    }
                    .nomidya-loader-center {
                        position: absolute;
                        top: 50%; left: 50%;
                        transform: translate(-50%, -50%);
                        width: 50px; height: 50px;
                        background: linear-gradient(135deg, ${C.blue} 0%, ${C.orange} 100%);
                        border-radius: 12px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: white;
                        font-size: 24px;
                        animation: nomidya-pulse 2s ease-in-out infinite;
                        box-shadow: 0 8px 24px rgba(0, 84, 166, 0.3);
                    }
                    .nomidya-loader-title {
                        font-size: 22px;
                        font-weight: 700;
                        color: ${C.blueDark};
                        margin: 0 0 8px;
                        letter-spacing: -0.3px;
                    }
                    .nomidya-loader-subtitle {
                        font-size: 14px;
                        color: #6b7280;
                        margin: 0 0 24px;
                        line-height: 1.6;
                    }
                    .nomidya-loader-dots {
                        display: flex;
                        justify-content: center;
                        gap: 10px;
                        margin-top: 20px;
                    }
                    .nomidya-loader-dot {
                        width: 10px;
                        height: 10px;
                        border-radius: 50%;
                        animation: nomidya-bounce 1.4s ease-in-out infinite;
                    }
                    .nomidya-loader-dot:nth-child(1) { background: ${C.blue}; animation-delay: 0s; }
                    .nomidya-loader-dot:nth-child(2) { background: ${C.orange}; animation-delay: 0.2s; }
                    .nomidya-loader-dot:nth-child(3) { background: ${C.blueDark}; animation-delay: 0.4s; }
                    .nomidya-loader-progress {
                        width: 100%;
                        height: 4px;
                        background: #e8eef5;
                        border-radius: 4px;
                        overflow: hidden;
                        margin-top: 24px;
                    }
                    .nomidya-loader-progress-bar {
                        height: 100%;
                        background: linear-gradient(90deg, ${C.blue} 0%, ${C.orange} 100%);
                        border-radius: 4px;
                        width: 30%;
                        animation: nomidya-progress 2s ease-in-out infinite;
                    }
                `}</style>

                <div className="nomidya-loader-card">
                    <div className="nomidya-loader-icon-wrapper">
                        <div className="nomidya-loader-ring"></div>
                        <div className="nomidya-loader-ring-2"></div>
                        <div className="nomidya-loader-center">
                            <VideoCameraOutlined />
                        </div>
                    </div>

                    <h2 className="nomidya-loader-title">
                        Chargement de la formation
                    </h2>

                    <p className="nomidya-loader-subtitle">
                        Préparation des détails et informations...
                    </p>

                    <div className="nomidya-loader-dots">
                        <div className="nomidya-loader-dot"></div>
                        <div className="nomidya-loader-dot"></div>
                        <div className="nomidya-loader-dot"></div>
                    </div>

                    <div className="nomidya-loader-progress">
                        <div className="nomidya-loader-progress-bar"></div>
                    </div>
                </div>
            </div>
        );
    }

    if (!training) return null;

    return (
        <div className="details-container">
            <style>{`
                .details-container { min-height: 100vh; background: #f8f9fa; }

                /* HERO BLEU NOMIDYA */
                .hero {
                    background: linear-gradient(135deg, ${C.blueDeep} 0%, ${C.blueDark} 50%, ${C.blue} 100%);
                    padding: 32px 0 60px;
                    color: white;
                    position: relative;
                    overflow: hidden;
                }
                .hero::before {
                    content: '';
                    position: absolute;
                    top: 0; left: 0;
                    width: 100%; height: 100%;
                    background-image:
                        radial-gradient(circle at 20% 50%, rgba(232,134,12,0.15) 0%, transparent 50%),
                        radial-gradient(circle at 80% 80%, rgba(255,255,255,0.08) 0%, transparent 50%);
                }
                .hero-content {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 0 32px;
                    position: relative;
                    z-index: 1;
                }
                .back-button {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    color: rgba(255,255,255,0.9);
                    background: rgba(255,255,255,0.15);
                    backdrop-filter: blur(10px);
                    padding: 8px 18px;
                    border-radius: 30px;
                    text-decoration: none;
                    font-size: 14px;
                    font-weight: 500;
                    transition: all 0.2s;
                    margin-bottom: 24px;
                    border: 1px solid rgba(255,255,255,0.2);
                }
                .back-button:hover {
                    background: rgba(255,255,255,0.25);
                    color: white;
                    transform: translateX(-4px);
                }
                .hero-grid {
                    display: grid;
                    grid-template-columns: 1.5fr 1fr;
                    gap: 40px;
                    align-items: start;
                }
                @media (max-width: 1024px) { .hero-grid { grid-template-columns: 1fr; } }

                .hero-info .badges {
                    display: flex;
                    gap: 8px;
                    margin-bottom: 16px;
                    flex-wrap: wrap;
                }

                .live-tag {
                    background: rgba(255,0,0,0.95);
                    color: white;
                    padding: 6px 14px;
                    border-radius: 20px;
                    font-size: 11px;
                    font-weight: 700;
                    letter-spacing: 1.5px;
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.2);
                }
                .live-tag::before {
                    content: '';
                    width: 8px; height: 8px;
                    background: white;
                    border-radius: 50%;
                    animation: pulse 1.5s infinite;
                }
                @keyframes pulse {
                    0%, 100% { opacity: 1; }
                    50% { opacity: 0.4; }
                }

                .category-tag {
                    background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%);
                    color: white;
                    padding: 6px 14px;
                    border-radius: 20px;
                    font-size: 12px;
                    font-weight: 700;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                    box-shadow: 0 4px 12px rgba(232,134,12,0.3);
                }

                .purchased-tag {
                    background: rgba(82,196,26,0.95);
                    color: white;
                    padding: 6px 14px;
                    border-radius: 20px;
                    font-size: 12px;
                    font-weight: 700;
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.2);
                }

                .hero-title {
                    font-size: 42px;
                    font-weight: 800;
                    line-height: 1.15;
                    margin: 0 0 16px;
                    text-shadow: 0 2px 10px rgba(0,0,0,0.2);
                }

                .hero-desc {
                    font-size: 17px;
                    line-height: 1.6;
                    opacity: 0.95;
                    margin-bottom: 24px;
                }

                .hero-meta {
                    display: flex;
                    gap: 24px;
                    flex-wrap: wrap;
                    font-size: 14px;
                }

                .hero-meta-item {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    color: rgba(255,255,255,0.95);
                }

                /* CARTE DE DROITE */
                .info-card-side {
                    background: white;
                    border-radius: 20px;
                    padding: 24px;
                    box-shadow: 0 10px 40px rgba(0,33,71,0.25);
                    color: #1a1a1a;
                }
                .info-card-side.purchased { border: 3px solid #52c41a; }

                .training-image {
                    width: 100%;
                    height: 220px;
                    border-radius: 12px;
                    object-fit: cover;
                    margin-bottom: 20px;
                }
                .training-image-placeholder {
                    width: 100%;
                    height: 220px;
                    border-radius: 12px;
                    background: linear-gradient(135deg, ${C.blueDark} 0%, ${C.blue} 100%);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    font-size: 80px;
                    margin-bottom: 20px;
                }

                /* PRIX - ORANGE Nomidya */
                .price-section {
                    background: linear-gradient(135deg, ${C.orange}11 0%, ${C.orangeLight}22 100%);
                    border: 2px solid ${C.orange}44;
                    padding: 16px;
                    border-radius: 12px;
                    text-align: center;
                    margin-bottom: 16px;
                }

                .price-label {
                    font-size: 12px;
                    color: ${C.blueDark};
                    text-transform: uppercase;
                    letter-spacing: 1px;
                    font-weight: 600;
                }

                .price-value {
                    font-size: 36px;
                    font-weight: 800;
                    color: ${C.orange};
                    line-height: 1;
                    margin-top: 4px;
                }

                .btn-subscribe {
                    width: 100%;
                    padding: 16px;
                    background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%);
                    color: white;
                    border: none;
                    border-radius: 12px;
                    font-size: 16px;
                    font-weight: 700;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 10px;
                    box-shadow: 0 8px 24px rgba(232,134,12,0.4);
                    transition: all 0.3s;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                }
                .btn-subscribe:hover:not(:disabled) {
                    transform: translateY(-2px);
                    box-shadow: 0 12px 32px rgba(232,134,12,0.5);
                    background: linear-gradient(135deg, ${C.orangeDark} 0%, ${C.orange} 100%);
                }
                .btn-subscribe:disabled { opacity: 0.6; cursor: not-allowed; }

                .btn-purchased {
                    width: 100%;
                    padding: 16px;
                    background: linear-gradient(135deg, #52c41a 0%, #389e0d 100%);
                    color: white;
                    border: none;
                    border-radius: 12px;
                    font-size: 16px;
                    font-weight: 700;
                    cursor: default;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 10px;
                    box-shadow: 0 8px 24px rgba(82,196,26,0.4);
                    text-transform: uppercase;
                    letter-spacing: 1px;
                }

                /* CONTENT */
                .content-section {
                    max-width: 1200px;
                    margin: -40px auto 0;
                    padding: 0 32px 60px;
                    position: relative;
                    z-index: 2;
                }

                .content-grid {
                    display: grid;
                    grid-template-columns: 1fr 320px;
                    gap: 32px;
                }

                @media (max-width: 1024px) { .content-grid { grid-template-columns: 1fr; } }

                .main-content { display: flex; flex-direction: column; gap: 24px; }

                .section-card {
                    background: white;
                    border-radius: 20px;
                    padding: 28px;
                    box-shadow: 0 4px 16px rgba(0,84,166,0.06);
                    border: 1px solid #f0f0f0;
                }

                .section-header {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    margin-bottom: 16px;
                    padding-bottom: 16px;
                    border-bottom: 2px solid #f0f7ff;
                }

                .section-icon {
                    width: 40px;
                    height: 40px;
                    border-radius: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    font-size: 18px;
                    background: linear-gradient(135deg, ${C.blueDark} 0%, ${C.blue} 100%);
                }

                .section-icon.orange {
                    background: linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%);
                }

                .section-title {
                    margin: 0;
                    font-size: 20px;
                    font-weight: 700;
                    color: #1a1a1a;
                }

                .section-content {
                    color: #4b5563;
                    line-height: 1.8;
                    font-size: 15px;
                }

                .sidebar {
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                    position: sticky;
                    top: 80px;
                    height: fit-content;
                }

                @media (max-width: 1024px) { .sidebar { position: static; } }

                .info-card {
                    background: white;
                    border-radius: 16px;
                    padding: 20px;
                    box-shadow: 0 4px 16px rgba(0,84,166,0.06);
                    border: 1px solid #f0f0f0;
                }

                .info-card-title {
                    font-size: 12px;
                    color: ${C.blueDark};
                    text-transform: uppercase;
                    letter-spacing: 1px;
                    font-weight: 700;
                    margin: 0 0 12px;
                    border-bottom: 2px solid #f0f7ff;
                    padding-bottom: 8px;
                }

                .info-list { display: flex; flex-direction: column; gap: 12px; }
                .info-item { display: flex; align-items: flex-start; gap: 10px; padding: 8px 0; }

                .info-item .anticon {
                    color: ${C.blue};
                    font-size: 18px;
                    margin-top: 2px;
                    flex-shrink: 0;
                }

                .info-label {
                    font-size: 11px;
                    color: #6b7280;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    margin-bottom: 2px;
                    font-weight: 600;
                }

                .info-value {
                    font-size: 14px;
                    color: #1a1a1a;
                    font-weight: 500;
                    line-height: 1.4;
                }

                .benefits-card {
                    background: linear-gradient(135deg, ${C.orange}08 0%, ${C.orangeLight}11 100%);
                    border: 1px solid ${C.orange}33;
                }

                .benefits-card .info-card-title {
                    color: ${C.orange};
                    border-bottom-color: ${C.orange}33;
                }

                .benefits-list { list-style: none; padding: 0; margin: 0; }
                .benefits-list li {
                    display: flex;
                    align-items: flex-start;
                    gap: 10px;
                    padding: 10px 0;
                    border-bottom: 1px solid #f5f7fa;
                    font-size: 14px;
                    color: #4b5563;
                }
                .benefits-list li:last-child { border-bottom: none; }
                .benefits-list .anticon {
                    color: #10b981;
                    font-size: 16px;
                    margin-top: 3px;
                    flex-shrink: 0;
                }

                @media (max-width: 768px) {
                    .hero-content { padding: 0 20px; }
                    .hero-title { font-size: 28px; }
                    .hero-desc { font-size: 15px; }
                    .content-section { padding: 0 20px 40px; }
                    .section-card { padding: 20px; }
                }
            `}</style>

            <div className="hero">
                <div className="hero-content">
                    <Link to="/live-trainings" className="back-button">
                        <ArrowLeftOutlined /> Retour aux formations
                    </Link>

                    <div className="hero-grid">
                        <div className="hero-info">
                            <div className="badges">
                                <span className="live-tag">LIVE</span>
                                {training.category?.libelle && (
                                    <span className="category-tag">{training.category.libelle}</span>
                                )}
                                {hasPurchased && (
                                    <span className="purchased-tag">
                                        <CheckCircleOutlined /> INSCRIT
                                    </span>
                                )}
                            </div>

                            <h1 className="hero-title">{training.title}</h1>

                            {training.short_desc && (
                                <p className="hero-desc">{training.short_desc}</p>
                            )}

                            <div className="hero-meta">
                                {training.duration && (
                                    <div className="hero-meta-item">
                                        <ClockCircleOutlined />
                                        <span>{training.duration}</span>
                                    </div>
                                )}
                                <div className="hero-meta-item">
                                    <DollarOutlined />
                                    <span>{training.price} €</span>
                                </div>
                            </div>
                        </div>

                        <div className={`info-card-side ${hasPurchased ? 'purchased' : ''}`}>
                            {training.image ? (
                                <img src={training.image} alt={training.title} className="training-image" />
                            ) : (
                                <div className="training-image-placeholder">
                                    <VideoCameraOutlined />
                                </div>
                            )}

                            <div className="price-section">
                                <div className="price-label">Prix de la formation</div>
                                <div className="price-value">{training.price} €</div>
                            </div>

                            {hasPurchased ? (
                                <div className="btn-purchased">
                                    <CheckCircleOutlined /> Vous êtes inscrit
                                </div>
                            ) : (
                                <button
                                    className="btn-subscribe"
                                    onClick={handleSubscribe}
                                    disabled={isProcessingPayment}
                                >
                                    {isProcessingPayment ? (
                                        <><LoadingOutlined /> Traitement...</>
                                    ) : (
                                        <><PlayCircleOutlined /> S'inscrire à la formation</>
                                    )}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="content-section">
                <div className="content-grid">
                    <div className="main-content">
                        {training.overview && (
                            <div className="section-card">
                                <div className="section-header">
                                    <div className="section-icon"><BulbOutlined /></div>
                                    <h2 className="section-title">À propos de cette formation</h2>
                                </div>
                                <div className="section-content" dangerouslySetInnerHTML={{ __html: training.overview }} />
                            </div>
                        )}

                        {training.what_you_will_learn && (
                            <div className="section-card">
                                <div className="section-header">
                                    <div className="section-icon orange"><FireOutlined /></div>
                                    <h2 className="section-title">Ce que vous allez apprendre</h2>
                                </div>
                                <div className="section-content" dangerouslySetInnerHTML={{ __html: training.what_you_will_learn }} />
                            </div>
                        )}

                        {training.requirements && (
                            <div className="section-card">
                                <div className="section-header">
                                    <div className="section-icon"><SafetyCertificateOutlined /></div>
                                    <h2 className="section-title">Prérequis</h2>
                                </div>
                                <div className="section-content" dangerouslySetInnerHTML={{ __html: training.requirements }} />
                            </div>
                        )}

                        {training.who_is_this_course_for && (
                            <div className="section-card">
                                <div className="section-header">
                                    <div className="section-icon"><TeamOutlined /></div>
                                    <h2 className="section-title">Public cible</h2>
                                </div>
                                <div className="section-content" dangerouslySetInnerHTML={{ __html: training.who_is_this_course_for }} />
                            </div>
                        )}
                    </div>

                    <div className="sidebar">
                        <div className="info-card">
                            <h3 className="info-card-title">📋 Informations</h3>
                            <div className="info-list">
                                {training.duration && (
                                    <div className="info-item">
                                        <ClockCircleOutlined />
                                        <div>
                                            <div className="info-label">Durée</div>
                                            <div className="info-value">{training.duration}</div>
                                        </div>
                                    </div>
                                )}
                                <div className="info-item">
                                    <DollarOutlined />
                                    <div>
                                        <div className="info-label">Prix</div>
                                        <div className="info-value">{training.price} €</div>
                                    </div>
                                </div>
                                {training.category?.libelle && (
                                    <div className="info-item">
                                        <TagsOutlined />
                                        <div>
                                            <div className="info-label">Catégorie</div>
                                            <div className="info-value">{training.category.libelle}</div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="info-card benefits-card">
                            <h3 className="info-card-title">✨ Avantages inclus</h3>
                            <ul className="benefits-list">
                                <li><CheckCircleOutlined /><span>Accès à la formation premium</span></li>
                                <li><CheckCircleOutlined /><span>Contenu interactif</span></li>
                                <li><CheckCircleOutlined /><span>Matériel pédagogique</span></li>
                                <li><CheckCircleOutlined /><span>Certificat de réussite</span></li>
                                <li><CheckCircleOutlined /><span>Support 7 jours</span></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                title="Connectez-vous pour vous inscrire"
                open={showLoginModal}
                onCancel={() => setShowLoginModal(false)}
                footer={null}
                centered
            >
                <p>Pour vous inscrire à cette formation, vous devez être connecté à votre compte.</p>
                <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
                    <button
                        onClick={() => navigate("/login")}
                        style={{
                            flex: 1, padding: 12,
                            background: `linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%)`,
                            color: 'white', border: 'none', borderRadius: 8,
                            fontWeight: 600, cursor: 'pointer',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                        }}
                    >
                        <LoginOutlined /> Se connecter
                    </button>
                    <button
                        onClick={() => navigate("/register")}
                        style={{
                            flex: 1, padding: 12,
                            background: 'white', color: C.blue,
                            border: `2px solid ${C.blue}`, borderRadius: 8,
                            fontWeight: 600, cursor: 'pointer',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                        }}
                    >
                        <UserOutlined /> Créer un compte
                    </button>
                </div>
            </Modal>

        </div>
    );
};

export default LiveTrainingDetails;
